module.exports = __webpack_public_path__ + "media/images/plans/wedding_reception/option-2-b07d873430c08b029592d741796609c6.png";